import { Button, Stack, Tooltip, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function WbKizSendControls({
  disabled,
  onSend,
  sent,
  busy,
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={onSend}
        disabled={disabled || busy}
      >
        {busy ? "Отправка…" : "Отправить в WB"}
      </Button>

      <Tooltip title={sent ? "КИЗ уже был отправлен в WB" : "Ещё не отправляли"}>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <CheckCircleOutlineIcon
            fontSize="small"
            color={sent ? "success" : "disabled"}
          />
          <Typography variant="caption" color={sent ? "success.main" : "text.disabled"}>
            {sent ? "Отправлен" : "Не отправлен"}
          </Typography>
        </Stack>
      </Tooltip>
    </Stack>
  );
}
